(() => {
  let cart = { items: [], original_total_price: 0, currency: window.Shopify?.currency?.active || 'USD' };
  function renderOffers() {
    document.querySelectorAll('[data-gleam-match-offers]').forEach(panel => {
      const product = panel.closest('.gleam-product');
      const quantity = Math.max(1, Number(product?.querySelector('quantity-input input')?.value || 1));
      const charmQuantity = cart.items.filter(item => /^(charms?|spacers?)$/i.test(item.product_type || '')).reduce((sum,item) => sum + item.quantity, 0);
      const selected = /^(charms?|spacers?)$/i.test(panel.dataset.productType) ? quantity : 0;
      const missing = (3 - (charmQuantity + selected) % 3) % 3;
      const count = charmQuantity + selected;
      const subtotal = (cart.original_total_price || 0) + Number(panel.dataset.price) * quantity;
      const target = subtotal < 7500 ? 7500 : 10000;
      const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cart.currency }).format(value / 100);
      const parts = [panel.dataset.prefix];
      if(selected) parts.push(count >= 3 && missing === 0 ? panel.dataset.ready : panel.dataset.more.replace('[count]', String(missing || 3)));
      if(subtotal < 10000) parts.push(panel.dataset.spend.replace('[amount]',money(target-subtotal)).replace('[percent]',target===7500?'15':'20'));
      else parts.push(panel.dataset.best);
      panel.querySelector('[data-gleam-match-progress]').textContent = parts.join(' ');
    });
  }
  document.addEventListener('gleam:cart', event => { if(event.detail?.items){cart=event.detail;renderOffers();} });
  document.addEventListener('change', event => { if(event.target.matches('quantity-input input'))renderOffers(); });
  document.addEventListener('input', event => { if(event.target.matches('quantity-input input'))renderOffers(); });
  document.addEventListener('shopify:section:load',renderOffers);
  renderOffers();
})();
